<template>
  <div
    ref="dropdownTrigger"
    class="relative z-20 bg-EXPONDO-white cursor-pointer"
    @click="onToggle"
  >
    <div
      class="flex justify-between border rounded p-2"
      :class="{'rounded-b-none': isOpen}"
    >
      <span class="font-bold select-none">{{ currentTitle }}</span>
      <div
        class="w-6 h-6 flex justify-center items-center"
      >
        <span
          class="iconify svg--chevron-right transform transition-transform"
          :class="isOpen ? '-rotate-90' : 'rotate-90'"
        />
      </div>
    </div>
    <div
      class="absolute left-0 w-full bg-EXPONDO-white rounded border-x rounded-t-none
          grid transition-[grid-template-rows]"
      :class="isOpen ? 'grid-rows-[1fr] border-b' : 'grid-rows-[0fr]'"
    >
      <div
        class="overflow-hidden"
        @click="onClick"
      >
        <CustomLink
          :url="slug"
          :type="LINK_TYPE.NoStyle"
          :is-block="true"
        >
          <div class="p-2 gap-2">
            <span class="font-bold">{{ dropdownTitle }}</span>
            <p>{{ dropdownDescription }}</p>
          </div>
        </CustomLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { onClickOutside } from '@vueuse/core';

import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'AlternativeProductDropdown',

  props: {
    slug: {
      type: String,
      required: true,
    },
    isAware: {
      type: Boolean,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const i18n = useI18n();
    const { trackClickAlternativeProduct } = useGtmEvents();

    const dropdownTrigger = ref(null);
    const isOpen = ref(false);

    const aWareTitle = i18n.t('New');
    const bWareTitle = i18n.t('Refurbished');

    const currentTitle = computed(() => props.isAware ? aWareTitle : bWareTitle);
    const dropdownTitle = computed(() => props.isAware ? bWareTitle : aWareTitle);
    const dropdownDescription = computed(() => props.isAware ? i18n.t('b-ware disclaimer') : '');

    onClickOutside(dropdownTrigger, () => {

      isOpen.value = false;
    
    });

    const onToggle = () => {

      isOpen.value = !isOpen.value;
    
    };

    const onClick = () => {

      trackClickAlternativeProduct(!props.isAware, props.sku);
    
    };

    return {
      dropdownTrigger,
      currentTitle,
      dropdownTitle,
      dropdownDescription,
      isOpen,
      LINK_TYPE,
      onToggle,
      onClick,
    };
  
  },
});


</script>
